import { OverlayRef } from '@angular/cdk/overlay';
import { BbitNaturalLanguageDateTimeParser } from '@bbitgmbh/bbit.natural-language-parser';
import { BbitI18n } from '@bbitgmbh/bbit.utils';
import { DateTime } from 'luxon';
import { BehaviorSubject, Subject } from 'rxjs';

export class DatePickerOverlayRef {
  public dateChangedSubject = new Subject<DateTime>();
  private _date: BehaviorSubject<DateTime> = new BehaviorSubject(DateTime.now());
  private _timezone = BbitI18n.getTimezone();
  private _parser = new BbitNaturalLanguageDateTimeParser();

  public constructor(private _overlayRef: OverlayRef) {
    this._parser.loadBuildInGrammars();
  }

  public close(): void {
    this._overlayRef.dispose();
  }

  public setDate(date: string | Date | DateTime): void {
    let dt: DateTime;
    if (typeof date === 'string') {
      try {
        dt = this._parser.parse(date);
        this._date.next(dt);
        return;
      } catch {
        // do nothing
      }
    }
    if (date instanceof Date) {
      dt = DateTime.fromJSDate(date);
    }
    if (!(date as DateTime)?.isValid) {
      dt = DateTime.now();
    } else {
      dt = date as DateTime;
    }
    this._date.next(dt);
  }

  public getDate(): BehaviorSubject<DateTime> {
    return this._date;
  }

  public setTimezone(timezone: string): void {
    this._timezone = timezone;
  }

  public getTimezone(): string {
    return this._timezone;
  }
}
